import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

import AmountInput from "../components/AmountInput";
import { getEntity } from "data/entity";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

class RecurringInfo extends React.Component {
  static propTypes = {
    paymentInterval: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { paymentInterval, handleAmountChange, selectedCausesCount, currencySymbol } =
      this.props;

    if (paymentInterval) {
      const paymentPerYear =
        paymentInterval === "monthly" ? 12 : paymentInterval === "quarterly" ? 4 : 1;
      const { intl } = this.props;

      return (
        <div className="donation-interval">
          <div className="half-width p-sm-r">
            <div>
              <FormattedMessage id="paymentsPerYear" />
            </div>
            <div className="f-1.5x p-sm-t">{paymentPerYear}</div>
          </div>
          <div className="donation-interval-border half-width p-sm-l">
            <div>{intl.formatMessage({ id: `${paymentInterval}Payment` })}</div>
            <div className="m-sm-t">
              <Field
                name="amount"
                type="number"
                className="donation-amount fa-lg"
                onValueChange={handleAmountChange}
                selectedCausesCount={selectedCausesCount}
                currencySymbol={currencySymbol}
                component={AmountInput}
              />
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => {
  const currentEntity = getEntity(state);

  return {
    currencySymbol: currentEntity.get("currency_symbol"),
  };
};

export default connect(mapStateToProps)(injectIntl(RecurringInfo));
